import * as CONSTANTS from '../../constants';
import {getBrowserName} from "../../../services/BrowserService";
import gatewayService from '../../../services/GatewayService';
import IPService from '../../../services/IPService';

/**
 * Send introduction confirmation.
 *
 * @param commit
 * @param payload
 */
export const sendConfirmation = ({commit}, payload) => {
    commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_PENDING);

    // Fetch ip information for the client
    return IPService.getIpInfo().then((res) => {
        const browser = getBrowserName();
        const ip = res.data.ip;
        return gatewayService.sendConfirmation(payload, ip, browser).then((res) => {
            if(res.status === 200) {
                commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_SUCCESS);
            } else {
                commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_NO_CONTENT);
            }
        }).catch((err) => {
            if(err.status === 400) {
                commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_WARNING);
            } else {
                commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_FAILURE);
            }
        })
    }).catch(() => {
        commit(CONSTANTS.INTRODUCTION_CONFIRM_SEND_FAILURE);
    });
};



// WEBPACK FOOTER //
// ./src/store/modules/introduction/actions.js